import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Phone, MessageSquare, X } from 'lucide-react';
export function FloatingContact() {
  const [isVisible, setIsVisible] = useState(false);
  const [isExpanded, setIsExpanded] = useState(false);
  useEffect(() => {
    const toggleVisibility = () => {
      if (window.scrollY > 500) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
        setIsExpanded(false);
      }
    };
    window.addEventListener('scroll', toggleVisibility);
    return () => window.removeEventListener('scroll', toggleVisibility);
  }, []);
  return <AnimatePresence data-id="element-129">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50,
      scale: 0.9
    }} animate={{
      opacity: 1,
      y: 0,
      scale: 1
    }} exit={{
      opacity: 0,
      y: 50,
      scale: 0.9
    }} transition={{
      duration: 0.3
    }} className="fixed bottom-6 right-6 z-50" data-id="element-130">
          <AnimatePresence data-id="element-131">
            {isExpanded && <motion.div initial={{
          opacity: 0,
          y: 20,
          scale: 0.95
        }} animate={{
          opacity: 1,
          y: 0,
          scale: 1
        }} exit={{
          opacity: 0,
          y: 20,
          scale: 0.95
        }} transition={{
          duration: 0.2
        }} className="absolute bottom-20 right-0 w-72 bg-white shadow-2xl border border-warmGray-dark overflow-hidden" data-id="element-132">
                <div className="bg-charcoal p-4 flex items-center gap-4" data-id="element-133">
                  <img src="https://assets.cdn.filesafe.space/yOon1ID2yH9FCnnAGN2G/media/6228f759ced3001c58d1474b.png" alt="Jenny Gong" className="w-12 h-12 rounded-full object-cover border-2 border-gold" data-id="element-134" />
                  <div data-id="element-135">
                    <h4 className="text-white font-serif text-lg" data-id="element-136">
                      Jenny Gong
                    </h4>
                    <p className="text-gold text-xs uppercase tracking-wider" data-id="element-137">
                      Luxury Realtor
                    </p>
                  </div>
                </div>
                <div className="p-4 space-y-3" data-id="element-138">
                  <a href="tel:+18583978218" className="flex items-center gap-3 w-full p-3 bg-warmGray hover:bg-gold hover:text-white text-charcoal transition-colors duration-300 group" data-id="element-139">
                    <Phone className="w-5 h-5 text-gold group-hover:text-white" data-id="element-140" />
                    <span className="font-medium text-sm uppercase tracking-wider" data-id="element-141">
                      Call Now
                    </span>
                  </a>
                  <a href="mailto:jenny@jennygong.com" className="flex items-center gap-3 w-full p-3 bg-warmGray hover:bg-charcoal hover:text-white text-charcoal transition-colors duration-300 group" data-id="element-142">
                    <MessageSquare className="w-5 h-5 text-charcoal group-hover:text-white" data-id="element-143" />
                    <span className="font-medium text-sm uppercase tracking-wider" data-id="element-144">
                      Send Message
                    </span>
                  </a>
                </div>
              </motion.div>}
          </AnimatePresence>

          <button onClick={() => setIsExpanded(!isExpanded)} className="w-16 h-16 bg-gold text-white rounded-full flex items-center justify-center shadow-lg hover:bg-gold-dark transition-colors duration-300 relative" data-id="element-145">
            {/* Pulse effect */}
            {!isExpanded && <span className="absolute inset-0 rounded-full bg-gold animate-ping opacity-20" data-id="element-146"></span>}

            {isExpanded ? <X className="w-6 h-6" data-id="element-147" /> : <Phone className="w-6 h-6" data-id="element-148" />}
          </button>
        </motion.div>}
    </AnimatePresence>;
}